<template>
	<div id="indexpage" v-title :data-title="title" style="height:100%;">
		<leftnav mkcode="D" itemcode="D-ZSHJ" :smScrennFull="true"></leftnav>
		<!-- 弹框 -->
		<div class="por" style="background-color: #041034;min-height:953px;height: 100vh;">
			<!-- 全屏开始 -->
			<i class="el-icon-full-screen swiper_fullscreen" @click="screen()"></i>
			<!-- 全屏结束 -->
			<div class="index-swiper centerpage">
				<!-- <h2 class="title dataswipertitle" @mouseover="drawer = true" >{{userdata.cityText}}</span>{{title}}<i class="el-icon-arrow-down dataswipertitle_icon"></i></h2> -->
				<navIcn :title="title" :indexnum="6" navcode="GDLAND" :fulltitle="true"  @yearChange="yearChange"></navIcn>
				<div class="indexflex zhaoshangmap">
					<div class="col2h  zsxm_left">
						<div class="zsxm_province">
							<h3 class="zsxm_title">重点来源城市 </h3>
							<div class="zsxm_nav">
							</div> 
							<div id="zsxm_province_money"  :style="'height:'+chartsHeight + 'px'">金额占比图表</div>
						</div>
						<div class="zsxm_detailed">
							<h3 class="zsxm_title">重点投资企业</h3>
							<div :style="'height:'+chartsHeight + 'px'">
								<div class="thbox">
								<ul class="flexcss">
									<li class="th_list1">投资企业</li>
									<li class="th_list1">拿地面积（亩）</li>
									<li class="th_list1">企业地点</li>
									<li class="th_list1">投资项目数</li>
								</ul>
							</div>
							<div class="zsxm_scrollbox">
								<vue-seamless-scroll :data="investmentlist"  :class-option="defaultOption" class="qysj_table_list">
									<!-- :data="colors"  :class-option="defaultOption" -->
									<ul class="qysj_tab flexcss" v-for="list in  investmentlist" :key="list.stockCode"> 
										<li class="th_list1" @click="routerlinkid('/enterprises',list.stockCode)">{{list.title}}</li> 
										<li class="th_list1">{{list.size}}</li>
										<li class="th_list1" >{{list.name}}</li>
										<li class="th_list1">{{list.num}}</li>
                                        
									</ul> 
								</vue-seamless-scroll>
							</div>
							</div>
						</div>
					</div>
					<div class="col5 colbox">
						<div id="zsxm_map"></div>
					</div> 
					<div class="col2h colbox transparentbg">
						<div class="zsxm_industry">
							<h3 class="zsxm_title">接收企业拿地投资行业分布</h3>
							<div id="zsxm_industry_money"  :style="'height:'+chartsHeight + 'px'"></div>
						</div>
						<div class="">
							<h3 class="zsxm_title">接收企业拿地面积全省排名</h3>
							<div id="zsxm_provincerank" :style="'height:'+chartsHeight + 'px'"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	</div>
</template>
<script>

import navIcn from "@/components/dataswiper-sass/HNZYB/navIcn.vue";
import { sortKey } from "@/utils/index.js";
export default {
	components: { navIcn },
	name: 'guandongInvest',
	data() {
		return {
			isCollapse: false,
			isFullscreen: false,
			direction: "ltr",  //btt
			direction2: "btt",  //btt
			drawer: false,
			drawer2: false,
			modal: false,
			title: "广东企业在湖南拿地投资",
			bgcolor: "#041034",
			usernotionlistsave: [],
			userdata: {},
			mapurl: 'map/city/321200.json',
			contodefault: {
				duration: 1000,
				autoplay: true,
			},
			islogin: false,
			flag: true,
			swipernum: 3,
			zsxm_nav: 1,
			city_nav: 1,
			pro_nav: 1,
			listdata: [],
			public_tooltip: {
				trigger: 'axis',
				backgroundColor: 'rgba(255,255,255,0.9)',
				borderColor: '#ddd',
				borderWidth: '1',
				textStyle: {
					color: '#000',
					fontSize: 14,
				}
			},
			colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
			landType: [],
			startCharts: null,
			//假数据 
			moydata1: [  //接收全国上市公司投资省份来源 金额占比
				{ value: 446.62, name: '广东省',num:64 },
				{ value: 294.58, name: '辽宁省' ,num:9},
				{ value: 165.78, name: '内蒙古自治区' ,num:3},
				{ value: 67.82, name: '浙江省' ,num:24},
				{ value: 53.32, name: '北京市' ,num:29},
				{ value: 45.69, name: '福建省' ,num:11},
				{ value: 34.61, name: '江苏省' ,num:16},
				{ value: 23.3, name: '河南省' ,num:5},
				{ value: 21.44, name: '重庆市' ,num:1},
				{ value: 21.12, name: '贵州省' ,num:5},
				{ value: 67.96, name: '其他' ,num:25},
			],
			moydata2: [
				{ name: '深圳市', value: 346.26 },
				{ name: '鞍山市', value: 276.8 },
				{ name: '巴彦淖尔市', value: 165.78 },
				{ name: '北京市', value: 53.32 },
				{ name: '佛山市', value: 34.69 },
				{ name: '杭州市', value: 33.53 },
				{ name: '广州市', value: 27.3 },
				{ name: '宁波市', value: 26.35 },
				{ name: '重庆市', value: 21.44 },
				{ name: '铜仁市', value: 20.8 },
				{ name: '其他', value: 92.53 },
			],
			moydata3: [
				{ name: '金属', value: 867.84},
				{ name: '装备制造', value: 492.61 },
				{ name: '能源电力', value: 212.08 },
				{ name: '化工行业', value: 211.13 },
				{ name: '信息技术及服务', value: 205.32 },
				{ name: '医疗医药', value: 119.5 },
				{ name: '非金属', value: 83.1 },
				{ name: '环保水务', value: 82.84 },
				{ name: '商贸', value: 77.65 },
				{ name: '农林牧渔', value: 73.4 },
				{ name: '其他', value: 265.23 },
			],
			moenydata: [  //接收全国上市公司投资省份来源 数值 
				{ city: '北京市', num: 2, money: 10.16 },
				{ city: '江西省', num: 5, money: 9 },
				{ city: '天津市', num: 8, money: 16.4 },
				{ city: '宁夏', num: 5, money: 35.18 },
				{ city: '江苏省', num: 42, money: 95.31 },
			],
			moenydata2: [  //接收全国上市公司投资城市来源 数值
				{ city: '重庆市', num: 5, money: 9 },
				{ city: '北京市', num: 2, money: 10.16 },
				{ city: '天津市', num: 8, money: 16.4 },
				{ city: '银川市', num: 4, money: 34.78 },
				{ city: '泰州市', num: 32, money: 88.51 },
			],
			moenydata3: [
				{ city: '农林牧渔', num: 4, money: 3.23 },
				{ city: '金融行业', num: 3, money: 12.2 },
				{ city: '医疗医药', num: 15, money: 43.4 },
				{ city: '化工行业', num: 11, money: 56.3 },
				{ city: '装备制造', num: 33, money: 66.37 },
			],
			fixassetsdata: [
				{ name: "长沙市", value: 865.97 },
				{ name: "郴州市", value: 802.4 },
				{ name: "株洲市", value: 326.92 },
				{ name: "岳阳市", value: 154.79 },
				{ name: "湘潭市", value: 130.42 },
				{ name: "娄底市", value: 116.31 },
				{ name: "衡阳市", value: 116.28 },
				{ name: "常德市", value: 65.37 },
				{ name: "益阳市", value: 60.18 },
				{ name: "永州市", value: 44.01 },
				{ name: "怀化市", value: 35.95 },
				{ name: "邵阳市", value: 26.42 },
				{ name: "张家界市", value: 17.31 },
				{ name: "湘西土家族苗族自治州", value: 5.51 },
			],
			ydata: [
				{ name: "广东", value: [113.23, 23.16],num:64  },
				{ name: "辽宁", value: [123.38,41.8] ,num:9},
				{ name: "内蒙古", value: [111.65,40.82] ,num:5},
				{ name: "浙江", value: [118.21, 29.11] ,num:42},
				{ name: "北京", value: [116.4, 39.9], num:2},
				{ name: "福建", value: [119.3, 26.08] , num:2},
				{ name: "江苏", value: [118.78, 32.04] , num:2},
				{ name: "河南", value: [113.65, 34.76] , num:2},
				{ name: "重庆", value: [106.54,29.59] , num:2},
				{ name: "贵州", value: [106.71,26.57] , num:2},
				{ name: "上海", value: [121.48,31.22] , num:2},
				{ name: "江西", value: [115.89, 28.68], num:2 },
				{ name: "河北", value: [114.52, 38.05] , num:2},
				{ name: "安徽", value: [117.27, 31.86] , num:2},
			],
			investmentlist: [],
			zbdata: [],
			zd: [113, 28.21], //大地图终点坐标
			startYear:"",
			endYear: "",
			chartsHeight: 360,
		}
	},
	props: {
		msg: String,
	},
	computed: {
		defaultOption() {
			return {
				step: 0.7, // 数值越大速度滚动越快
				limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			}
		}
	},

	mounted() {
		let jdata = require('../../../../public/map/geo.json');  //引入json文件
		document.getElementById('app').style.background = this.bgcolor;
		this.userdata = this.getuseriformation();
		// console.log(this.userdata);
		// this.bus.$emit('loading', true);
		// if (this.userdata.edition < 1) {
		// 	var _this = this;
		// 	alert('升级版本后即可查看本页面,自动跳转');
		// 	setTimeout(function () {
		// 		_this.routerself('/totalEnterprises');
		// 	}, 1000)
		// 	return;
		// }
		this.getajasdata();
		this.chartsHeight = document.body.clientHeight/2.5;
		console.log('页面高度', this.chartsHeight);
		// // for(var i=0;i<this.zbdata.length;i++){
		// // 	 if(this.zbdata[i].name==this.userdata.cityText){
		// // 			this.zd=[this.zbdata[i].longitude,this.zbdata[i].latitude];
		// // 		}
		// // }
		// for (var i = 0; i < jdata.length; i++) {
		// 	if (jdata[i].name == this.userdata.cityText) {
		// 		this.zd = [jdata[i].longitude, jdata[i].latitude];
		// 	}
		// }
		
	},
	methods: { 
			
yearChange(list) {
			this.startYear = list.startYear, this.endYear = list.endYear;
			// console.log(list);
			this.getajasdata();
		},
		getajasdata() {
			var _this = this;
			this.bus.$emit('loading', true);
			console.log(this.title);
			this.$axios.get(this.$api.cyl.GovProvinceChart.GuandongLand()+'?startYear='+this.startYear+'&endYear='+this.endYear, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log(res.data.data);
				if (res.data.success) {
                    console.log('调试信息，停止执行',res); 
					var datd = res.data.data;
					_this.moydata1 = res.data.data.province;
					_this.moydata2 = res.data.data.city;
					_this.moydata3 = res.data.data.industry;
					_this.investmentlist = res.data.data.enterprise;
					_this.PiechartFun('zsxm_province_money', res.data.data.city);  //接收全国上市公司投资省份来源
					_this.rankFun('zsxm_industry_money', res.data.data.industry,2); //接收上市公司投资行业分布
					_this.rankFun('zsxm_provincerank', res.data.data.targetCity,1); //接收投资金额全省排名
					_this.chianmapFun('zsxm_map', res.data.data.map); //地图
					_this.bus.$emit('loading', false);
				}
			}).catch(function (error) {
				//请求失败处理 console.log(error);
			});
		},

		//1大地图飞线图
		chianmapFun(el, data, scdata) {
			// 修正点位/飞线位置、隐藏南海诸岛、仅突出显示湖南与广东（保留中国底图）
			const _this = this;
            var lagData  = this.$geoJson;
			// helper：从多个来源寻找省级坐标，返回 [lng, lat] 或 null
			function findProvinceCoord(sources, provinceKeywords = ['广东', '广东省']) {
				if (!Array.isArray(sources)) return null;
				for (const item of sources) {
					if (!item || !item.name) continue;
					for (const k of provinceKeywords) {
						if (item.name.indexOf(k) !== -1) {
							// 常见：坐标可能在 item.value (数组) 或 item.value 对应数值时在 item.coord
							if (Array.isArray(item.value) && item.value.length === 2) return item.value;
							if (Array.isArray(item.coord) && item.coord.length === 2) return item.coord;
						}
					}
				}
				return null;
			}

			// 尝试从 scdata、data、组件 ydata 中查找广东坐标
			let guangdongCoord = findProvinceCoord(scdata) || findProvinceCoord(data);
			if (!guangdongCoord && Array.isArray(this.ydata)) {
				const gd = this.ydata.find(d => d && d.name && d.name.indexOf('广东') !== -1);
				if (gd && Array.isArray(gd.value) && gd.value.length === 2) guangdongCoord = gd.value;
			}
			// 湖南坐标来源：this.zd（确保为 [lng, lat]）
			let hunanCoord = Array.isArray(_this.zd) && _this.zd.length === 2 ? _this.zd : null;

			// 保留原始完整地图数据，避免投影问题
			const mapData = Array.isArray(data) ? data : [];

			// 构造 scatter 与 lines 数据（仅在两点都存在时）
			let scatterData = [];
			let lineData = [];
			console.log('guangdongCoord:', lagData);
			if (guangdongCoord && hunanCoord) {
                
                for(let i = 0; i <data.length;i++){
                    //// 递归处理子对象
                    for (let key in lagData) {
                        if (typeof lagData[key] === 'object' && lagData[key] !== null  ) {
                            if(data[i].sourceName == key){
                                scatterData.push({
                                    // name: data[i].sourceName,
                                    value: lagData[key],
                                });
                                
                            }
                             if(data[i].targetName == key){
                                lineData.push({
                                    coords: [
                                        lagData[data[i].sourceName], lagData[data[i].targetName],
                                        
                                    ],
                                    value: 1,
                                    money : data[i].money,
                                    num : data[i].num,
                                    targetName : data[i].targetName,
                                    sourceName : data[i].sourceName,
									unit : data[i].unit,
									size : data[i].size,
									sizeUnit : data[i].sizeUnit
                                });
                            }
                        }
                    }
                }
               
				 
			}
            console.log('scatterData:', scatterData, 'lineData:', lineData);
            // return; // 暂时屏蔽飞线效果

			// 计算两点中心与合适 zoom（经验值）
			let center = [105.87, 37.2];
			let zoom = 1.0;
			if (guangdongCoord && hunanCoord) {
				center = [(guangdongCoord[0] + hunanCoord[0]) / 2, (guangdongCoord[1] + hunanCoord[1]) / 2];
				const dx = Math.abs(guangdongCoord[0] - hunanCoord[0]);
				const dy = Math.abs(guangdongCoord[1] - hunanCoord[1]);
				const maxDiff = Math.max(dx, dy);
                console.log('maxDiff:', maxDiff);
				if (maxDiff < 3) zoom = 1.6;
				else if (maxDiff < 6) zoom = 1.7;
				else if (maxDiff < 12) zoom = 2.5;
				else zoom = 2;
			}

			const myChart = echarts.init(document.getElementById(el));
			const loadedDataURL = 'map/map.json';
			const mapName = 'china';
			$.getJSON(loadedDataURL, function (geoJson) {
				echarts.registerMap(mapName, geoJson);
				myChart.hideLoading();
				//区分湖南和广东
				const regionsOverride = [];
				(geoJson.features || []).forEach(f => {
					const props = f.properties || {};
					const name = props.name || '';
					const adcode = String(props.adcode || '');
					if (!name) return;

					const prefix = adcode.slice(0, 2);

					if (prefix === '43') { // 湖南
						regionsOverride.push({
							name: name,
							itemStyle: {
								normal: {
									areaColor: '#2B90D2',  // 湖南用蓝色
									borderColor: '#fff',
									borderWidth: 0.6
								}
							},
							label: { show: true, color: '#fff' }
						});
					}
					else if (prefix === '44') { // 广东
						regionsOverride.push({
							name: name,
							itemStyle: {
								normal: {
									areaColor: '#2B79D2',  // 广东用橙色
									borderColor: '#fff',
									borderWidth: 0.6
								}
							},
							label: { show: true, color: '#fff' }
						});
					}
					else if (name.indexOf('南海诸岛') !== -1) {
						regionsOverride.push({
							name: name,
							itemStyle: { normal: { areaColor: 'rgba(0,0,0,0)', borderColor: 'rgba(0,0,0,0)' } }
						});
					}
				});
				console.log('regionsOverride:', regionsOverride, geoJson);
				const option = {
					backgroundColor: _this.bgcolor,
					tooltip: {
						show: true,
						trigger: 'item'
					},
					geo: {
						map: mapName,
						center: center,
						zoom: zoom,
						layoutCenter: ['50%', '50%'],
						layoutSize: '100%',
						silent: true,
						roam: false,
						itemStyle: {
							normal: {
								areaColor: 'rgba(46,87,157,0.06)', // 其他省淡色
								borderColor: '#07232c',
								borderWidth: 0.6,
							},
							emphasis: {
								areaColor: '#0e2240',
								borderWidth: 1,
							}
						},
						// 尝试隐藏南海诸岛（覆盖样式）
						regions: regionsOverride,
					},
					series: [
						// {
						// 	name: 'map',
						// 	type: 'map',
						// 	map: mapName,
						// 	center: center,
						// 	zoom: zoom,
						// 	layoutCenter: ['50%', '50%'],
						// 	layoutSize: '100%',
						// 	label: { show: true, color: '#fff', fontSize: 12 },
						// 	itemStyle: {
						// 		normal: { borderColor: '#fff',areaColor: '#2e579d', borderWidth: 0.6 }
						// 	},
						// 	// 高亮/覆盖广东与湖南，隐藏南海诸岛
						// 	regions: [
						// 		{ name: '广东省', itemStyle: { normal: { areaColor: '#0e2240' } }, label: { show: true } },
						// 		{ name: '广东', itemStyle: { normal: { areaColor: '#2e579d' } } },
						// 		{ name: '湖南省', itemStyle: { normal: { areaColor: '#2e579d' } }, label: { show: true } },
						// 		{ name: '湖南', itemStyle: { normal: { areaColor: '#2e579d' } } },
						// 		{ name: '南海诸岛', itemStyle: { normal: { areaColor: 'rgba(0,0,0,0)', borderColor: 'rgba(0,0,0,0)' } } }
						// 	],
						// 	data: mapData,
                        //     tooltip: {
                        //         show: false,
                        //     }
						// },
						{
							type: 'effectScatter',
							coordinateSystem: 'geo',
							data: scatterData,
							rippleEffect: { scale: 5, brushType: 'fill', period: 3 },
							symbolSize: function (val) { return 8; },
							itemStyle: { color: '#e4bb38 ',  shadowBlur: 10 },
							label: { show: false, formatter: '{b}', position: 'right', color: '#fff' },
                            tooltip: { show: false, }
						},
						{
							type: 'lines',
							coordinateSystem: 'geo',
							zlevel: 2,
							effect: {
							show: true,
							period: 0.8, // 箭头指向速度，值越小速度越快
							trailLength: 0.01, // 特效尾迹的长度。取从 0 到 1 的值，数值越大尾迹越长。
							symbol: 'triangle', // 特效图形的标记。
							symbolSize: 8 // 特效标记的大小
						},
							lineStyle: {
							normal: {
								width: 2, // 尾迹线条宽度
								color: '#e4bb38 ', // 线颜色
								opacity: 0.1, // 尾迹线条透明度
								curveness: 0.2,// 边的曲度，支持从 0 到 1 的值，值越大曲度越大。 
							}
						},
							data: lineData,
                            tooltip: { //提示框组件。
							show: true,
							alwaysShowContent: true,
							hoverAnimation: true,
							trigger: 'item', //触发类型 散点图
							enterable: true, //鼠标是否可进入提示框
							transitionDuration: 1, //提示框移动动画过渡时间
							triggerOn: 'click',
							borderWidth: '1px',
							borderRadius: '4',
							// borderColor: '#00B2AC',
							backgroundColor: "rgba(0,0,0,.6)",
							textStyle: {
								color: 'rgba(255,255,255,1)'
							},
							padding: [10, 10],
							formatter: function (params) {
								var result = '';
								if (!isNaN(params.value)) {
									result = params.data.sourceName +' - ' + params.data.targetName + '<br>' +
                                        // '投资金额（'+ params.data.unit+'）：' + params.data.money + '<br>' +
										'拿地面积（'+ params.data.sizeUnit+'）：' + params.data.size;
								} else {
									result = params.name;
								}
								// console.log(params);
								return result;
							},

						},
						}
					]
				};

				myChart.setOption(option);
				// 自适应容器大小
				setTimeout(() => { window.onresize = () => myChart.resize(); }, 200);
			});
		},


		//饼图fn
		PiechartFun(el, data) {
			console.log('进入饼图');
			var charPie3currentIndex = 0,
				isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var regionalchart = echarts.init(document.getElementById(el));
			for (var i = 0; i < data.length; i++) {
				data[i].value = data[i].size;
			}
			var _this = this;
			var option = {
				title: {
					text: ' ',
				},
				tooltip: {
					trigger: 'item'
				},
				// legend: {top: 'center',right:'15%',textStyle:{color:"#eee",fontSize:12,lineHeight:100},orient:'vertical',itemWidth:6,itemHeight:6, icon:'circle'	//图例圆形
				// },
				series: [{
					name: '',
					type: 'pie',
					radius: '55%',
					// center: ["52%", "50%"],
					data: data,
					label: {
						show: true,
						color: '#eee',
						fontSize: 12,
						position: 'outside',
						formatter: '{b} : {d}%',
					},
					tooltip: { //提示框组件。
							show: true,
							alwaysShowContent: true,
							hoverAnimation: true,
							trigger: 'item', //触发类型 散点图
							enterable: true, //鼠标是否可进入提示框
							transitionDuration: 1, //提示框移动动画过渡时间
							triggerOn: 'click',
							borderWidth: '1px',
							borderRadius: '4',
							// borderColor: '#00B2AC',
							backgroundColor: "rgba(0,0,0,.6)",
							textStyle: {
								color: 'rgba(255,255,255,1)'
							},
							padding: [10, 10],
							formatter: function (params) {
								var result = '';
								if (!isNaN(params.value)) {
									result = 
                                        // '投资金额（'+ params.data.moneyUnit+'）：' + params.data.money + '<br>' +
										'拿地面积（'+ params.data.sizeUnit+'）：' + params.data.size;
								} else {
									result = params.name;
								}
								// console.log(params);
								return result;
							},

						},
					emphasis: {
						itemStyle: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: 'rgba(0, 0, 0, 0.5)'
						}
					},
					
				}]
			};
			regionalchart.setOption(option);
			setTimeout(function () {
				window.onresize = function () {
					regionalchart.resize();
				}
			}, 200)
		},

		//1
		numFun(el, data) {
			console.log(data);
			var projectchart = echarts.init(document.getElementById(el));
			// var yData = ['2016年', '2017年', '2018年', '2019年','2020年'];
			var _this = this,
				xdata1 = [],
				xdata2 = [],
				yData = [];
			for (var i = 0; i < data.length; i++) {
				xdata1.push(data[i].money);
				xdata2.push(data[i].num);
				// data[i].city=data[i].name;
				yData.push(data[i].name);
			}
			var option = {
				title: {
					text: ''
				},
				tooltip: {
					formatter: "{b}：{a}{c}",
					confine: true, //提示框被遮挡  是否将 tooltip 框限制在图表的区域内 
				},
				grid: [{ // 左侧对应坐标系
					show: false,
					left: '10%',
					top: '10%',
					bottom: '10%',
					width: '40%'
				},
				{ // 右侧对应坐标系
					show: false,
					left: '51%',
					top: '10%',
					bottom: '10%',
					width: '40%'
				},
				{ // 用来显示的坐标系
					show: false,
					left: '15%',
					top: '10%',
					bottom: '10%',
					width: '80%'
				}
				],
				// x轴是度量，y轴是维度
				xAxis: [{ // 左侧轴
					type: 'value',
					inverse: true,
					min: 0,
					// max: val => {
					//     return Math.floor((val.max) * 1.1);
					// }, 
					axisLine: { //轴线
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false, //轴标签
						textStyle: {
							color: '#999',
							fontSize: 12
						}
					},
					splitLine: {
						show: false
					}
				},
				{ // 右侧轴
					type: 'value',
					gridIndex: 1,
					min: 0,
					// max: val => {
					//     return Math.floor((val.max) * 1.1);
					// },
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						textStyle: {
							color: '#999',
							fontSize: 12
						}
					},
					splitLine: {
						show: false
					}
				},
				{ // 最左侧y轴对应x轴
					gridIndex: 2,
					name: 'x',
					nameLocation: 'center',
					nameGap: 40, // 与坐标轴距离
					nameTextStyle: {
						color: '#999999',
						fontSize: 12
					},
					axisLine: {
						show: false
					}
				}
				],
				yAxis: [{
					type: 'category',
					position: 'right',
					axisLine: {
						show: false
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						margin: 0
					},
					data: yData
				},
				//右侧y轴
				{
					gridIndex: 1,
					type: 'category',
					position: 'left',
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false,
					},
					axisLabel: {
						show: false
					},
					data: yData
				},
				{
					name: '',
					gridIndex: 2,
					type: 'category',
					position: 'left',
					nameLocation: 'end',
					nameGap: 25, // 与坐标轴距离
					nameTextStyle: {
						color: '#999999',
						fontSize: 12
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						textStyle: {
							color: '#000',
							fontSize: 12
						}
					},
					data: yData
				}
				],
				series: [{
					name: '投资金额(亿元)',
					type: 'bar',
					xAxisIndex: 0,
					yAxisIndex: 0,
					// barWidth: '20%',
					itemStyle: { //通常情况下：
						normal: {
							//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
							// color: function(params) {
							// 	var colorList = ['#5689ef', '#55cea1', '#596c8e', '#eab518','#a8c3ef','#e98eef','#efb1a4','#ef6e2d','#00ffff','#ecef15','#aa0000','#005500','#55557f','#5500ff','#ffff7f','#55aaff','#b1efaa','#aa55ff','#aaaa7f','#6a5bef',];
							// 	return colorList[params.dataIndex];
							// }
							// color:function(d){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}
						},
					},
					label: {
						normal: {
							show: false,
							position: 'left', //显示顶部数据
							color: '#fff',
						}
					},
					data: xdata1,
					// barCategoryGap:'5%',
				},
				]
			};
			projectchart.setOption(option);
		},

		//2
		numFun2(el, data) {
			var projectchart = echarts.init(document.getElementById(el));
			// var yData = ['2016年', '2017年', '2018年', '2019年','2020年'];
			var _this = this,
				xdata1 = [],
				xdata2 = [],
				yData = [];
			for (var i = 0; i < data.length; i++) {
				xdata1.push(data[i].money);
				xdata2.push(data[i].num);
				yData.push(data[i].name);
			}
			var option = {
				title: {
					text: ''
				},
				tooltip: {
					formatter: "{b}：{a}{c}"
				},
				grid: [{ // 左侧对应坐标系
					show: false,
					left: '10%',
					top: '10%',
					bottom: '10%',
					width: '40%'
				},
				{ // 右侧对应坐标系
					show: false,
					left: '51%',
					top: '10%',
					bottom: '10%',
					width: '40%'
				},
				{ // 用来显示的坐标系
					show: false,
					left: '15%',
					top: '10%',
					bottom: '10%',
					width: '80%'
				}
				],
				// x轴是度量，y轴是维度
				xAxis: [{ // 左侧轴
					type: 'value',
					inverse: true,
					min: 0,
					// max: val => {
					//     return Math.floor((val.max) * 1.1);
					// }, 
					axisLine: { //轴线
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false, //轴标签
						textStyle: {
							color: '#999',
							fontSize: 12
						}
					},
					splitLine: {
						show: false
					}
				},
				{ // 右侧轴
					type: 'value',
					gridIndex: 1,
					min: 0,
					// max: val => {
					//     return Math.floor((val.max) * 1.1);
					// },
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						textStyle: {
							color: '#999',
							fontSize: 12
						}
					},
					splitLine: {
						show: false
					}
				},
				{ // 最左侧y轴对应x轴
					gridIndex: 2,
					name: 'x',
					nameLocation: 'center',
					nameGap: 40, // 与坐标轴距离
					nameTextStyle: {
						color: '#999999',
						fontSize: 12
					},
					axisLine: {
						show: false
					}
				}
				],
				yAxis: [{
					type: 'category',
					position: 'right',
					axisLine: {
						show: false
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						margin: 0
					},
					data: yData
				},
				//右侧y轴
				{
					gridIndex: 1,
					type: 'category',
					position: 'left',
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false,
					},
					axisLabel: {
						show: false
					},
					data: yData
				},
				{
					name: '',
					gridIndex: 2,
					type: 'category',
					position: 'left',
					nameLocation: 'end',
					nameGap: 25, // 与坐标轴距离
					nameTextStyle: {
						color: '#999999',
						fontSize: 12
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						textStyle: {
							color: '#000',
							fontSize: 12
						}
					},
					data: yData
				}
				],
				series: [{
					name: '投资金额(亿元)',
					type: 'bar',
					xAxisIndex: 0,
					yAxisIndex: 0,
					// barWidth: '20%',
					itemStyle: { //通常情况下：
						normal: {
							//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
							// color: function(params) {
							// 	var colorList = ['#5689ef', '#55cea1', '#596c8e', '#eab518','#6a5bef'];
							// 	return colorList[params.dataIndex];
							// }
						},
					},
					label: {
						normal: {
							show: false,
							position: 'left', //显示顶部数据
							color: '#fff',
						}
					},
					data: xdata1,
					// barCategoryGap:'5%',
				},
				{
					name: '投资数量（个）',
					type: 'bar',
					xAxisIndex: 1,
					yAxisIndex: 1,
					// barMaxWidth: '20%',
					itemStyle: { //通常情况下：
						normal: {
							//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
							// color: function(params) {
							// 	var colorList = ['#5689ef', '#55cea1', '#596c8e', '#eab518',
							// 	'#6a5bef'];
							// 	return colorList[params.dataIndex];
							// }
						},
					},
					label: {
						normal: {
							show: false,
							position: 'right', //显示顶部数据
							color: '#fff',
						}
					},
					data: xdata2,
				}
				]
			};
			projectchart.setOption(option);
		},
		//3
		numFun3(el, data) {
			var projectchart = echarts.init(document.getElementById(el));
			// var yData = ['2016年', '2017年', '2018年', '2019年','2020年'];
			var _this = this,
				xdata1 = [],
				xdata2 = [],
				yData = [];
			for (var i = 0; i < data.length; i++) {
				xdata1.push(data[i].money);
				xdata2.push(data[i].num);
				yData.push(data[i].name);
			}
			var option = {
				title: {
					text: ''
				},
				tooltip: {
					formatter: "{b}：{a}{c}"
				},
				grid: [{ // 左侧对应坐标系
					show: false,
					left: '10%',
					top: '10%',
					bottom: '10%',
					width: '40%'
				},
				{ // 右侧对应坐标系
					show: false,
					left: '51%',
					top: '10%',
					bottom: '10%',
					width: '40%'
				},
				{ // 用来显示的坐标系
					show: false,
					left: '15%',
					top: '10%',
					bottom: '10%',
					width: '80%'
				}
				],
				// x轴是度量，y轴是维度
				xAxis: [{ // 左侧轴
					type: 'value',
					inverse: true,
					min: 0,
					// max: val => {
					//     return Math.floor((val.max) * 1.1);
					// }, 
					axisLine: { //轴线
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false, //轴标签
						textStyle: {
							color: '#999',
							fontSize: 12
						}
					},
					splitLine: {
						show: false
					}
				},
				{ // 右侧轴
					type: 'value',
					gridIndex: 1,
					min: 0,
					// max: val => {
					//     return Math.floor((val.max) * 1.1);
					// },
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						textStyle: {
							color: '#999',
							fontSize: 12
						}
					},
					splitLine: {
						show: false
					}
				},
				{ // 最左侧y轴对应x轴
					gridIndex: 2,
					name: 'x',
					nameLocation: 'center',
					nameGap: 40, // 与坐标轴距离
					nameTextStyle: {
						color: '#999999',
						fontSize: 12
					},
					axisLine: {
						show: false
					}
				}
				],
				yAxis: [{
					type: 'category',
					position: 'right',
					axisLine: {
						show: false
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						margin: 0
					},
					data: yData
				},
				//右侧y轴
				{
					gridIndex: 1,
					type: 'category',
					position: 'left',
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false,
					},
					axisLabel: {
						show: false
					},
					data: yData
				},
				{
					name: '',
					gridIndex: 2,
					type: 'category',
					position: 'left',
					nameLocation: 'end',
					nameGap: 25, // 与坐标轴距离
					nameTextStyle: {
						color: '#999999',
						fontSize: 12
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						textStyle: {
							color: '#000',
							fontSize: 12
						}
					},
					data: yData
				}
				],
				series: [{
					name: '投资金额(亿元)',
					type: 'bar',
					xAxisIndex: 0,
					yAxisIndex: 0,
					// barWidth: '20%',
					itemStyle: { //通常情况下：
						normal: {
							//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
							// color: function(params) {
							// 	var colorList = ['#5689ef', '#55cea1', '#596c8e', '#eab518',
							// 	'#6a5bef','#c1a5d5'];
							// 	return colorList[params.dataIndex];
							// }
						},
					},
					label: {
						normal: {
							show: false,
							position: 'left', //显示顶部数据
							color: '#fff',
						}
					},
					data: xdata1,
					// barCategoryGap:'5%',
				},
				{
					name: '投资数量（个）',
					type: 'bar',
					xAxisIndex: 1,
					yAxisIndex: 1,
					// barMaxWidth: '20%',
					itemStyle: { //通常情况下：
						normal: {
							//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
							// color: function(params) {
							// 	var colorList = ['#5689ef', '#55cea1', '#596c8e', '#eab518',
							// 	'#6a5bef','#c1a5d5'];
							// 	return colorList[params.dataIndex];
							// }
						},
					},
					label: {
						normal: {
							show: false,
							position: 'right', //显示顶部数据
							color: '#fff',
						}
					},
					data: xdata2,
				}
				]
			};
			projectchart.setOption(option);
		},

		//接收投资金额全省排名
		rankFun(el, data,type) {
			var charPie3currentIndex = 0,
				isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var chart = echarts.init(document.getElementById(el));
			var _this = this,
				xline = [],
				seriesline = [];
			var datalen = data.length - 1;
			data = sortKey(data, 'size',1);
			for (var i = 0; i < data.length; i++) {
				// xline.push(data[datalen - i].city);
				// seriesline.push(data[datalen - i].data);
				//从大到小排列
				if(i<14){
					xline.unshift(data[ i].name);
					seriesline.unshift(data[i].size);
				}
			};
			// console.log(data,xline,seriesline)
			var option = {
				title: {
					text: "",
					left: 25,
					top: 20,
					textStyle: {
						color: '#eee',
						fontSize: 16
					}
				},
				tooltip: {
					formatter: "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff'></span>{b}：{c} （亩）"
				},
				color: _this.colors,
				grid: {
					x: type == 1? 78:200,
					y: 10,
					x2: 50,
					y2: 20,
					show: true,
					borderWidth: 0,
				},
				label: {
					show: false,
					position: 'right',
					valueAnimation: true,
					color: '#fff',
					formatter: '{@score}' + '亩'
				},
				xAxis: {
					type: 'value',
					axisTick: {
						show: false
					},
					boundaryGap: [0, 0.01],
					splitLine: {
						show: false
					},
					axisLabel: {
						fontSize: 12,
						color: '#eee'
					}
				},
				yAxis: {
					type: 'category',
					splitLine: {
						show: false
					},
					axisTick: {
						show: false
					},
					axisLine: {
						show: true
					},
					data: xline,
					axisLabel: {
						fontSize: 12,
						color: '#eee'
					}
				},
				series: [{
					data: seriesline,
					type: 'bar',
					barWidth: 20,
				}]
			};
			chart.setOption(option);
			 
		},
	}
}
</script>

<style scoped="scoped" lang="scss">
#app {
	background-color: #041034;
}
@import url('/src/css/dataswiper.css');
.zsxm_scrollbox{
	height: 340px !important;
}
</style>
